import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Pedidos emitidas
    ordersEmit: {
      tableData: [],
      totalOrdersEmit: 0
    },
    queryOrdersEmit: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersOrdersEmit: [],

    // Pedidos Recibidas
    ordersReceived: {
      tableData: [],
      totalOrdersReceived: 0
    },
    queryOrdersReceived: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'RECEIVED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersOrdersReceived: [],
    // Combo estados pedidos
    optionsFilterStatusOrder: [],
    optionsFilterOrderType: [],

    // Datos Select Filtros Pedidos Emitidas
    optionsFilterBuyerOrderEmit: [],
    optionsFilterSellerOrderEmit: [],
    optionsFilterDateCreationOrderEmit: [],
    optionsFilterDateIssueOrderEmit: [],
    optionsFilterOrderNumberOrderEmit: [],
    // Datos Select Filtros Pedidos recibidas
    optionsFilterBuyerOrderReceived: [],
    optionsFilterSellerOrderReceived: [],
    optionsFilterDateCreationOrderReceived: [],
    optionsFilterDateIssueOrderReceived: [],
    optionsFilterOrderNumberOrderReceived: [],
    optionsFilterDeliveryDateFromOrderReceived: [],
    optionsFilterDeliveryDateToOrderReceived: [],
    optionsFilterDeliveryDateFromOrderEmit: [],
    optionsFilterDeliveryDateToOrderEmit: []
  }
  return session
}
function initLocal () {
  const local = {

    // Columnas Tabla Pedidos Emitidas
    isShowBuyerOrderEmit: true,
    isShowSellerOrderEmit: true,
    isShowNumOrderEmit: true,
    isShowDateCreationOrderEmit: true,
    isShowDateIssueOrderEmit: true,
    isShowStatusOrderEmit: true,
    isShowServiceOrderEmit: true,
    isShowCentroVendedorOrderEmit: false,
    isShowCentroCompradorOrderEmit: false,
    isShowCentroEntregaOrderEmit: true,
    isShoworderTypeEmit: true,
    isShowDeliveryDateFromOrderEmit: true,
    isShowDeliveryDateToOrderEmit: true,

    // Columnas Tabla Pedidos recibidas
    isShowBuyerOrderReceived: true,
    isShowSellerOrderReceived: false,
    isShowNumOrderReceived: true,
    isShowDateCreationOrderReceived: false,
    isShowDateIssueOrderReceived: true,
    isShowStatusOrderReceived: true,
    isShowServiceOrderReceived: false,
    isShowCentroVendedorOrderReceived: false,
    isShowCentroCompradorOrderReceived: true,
    isShowCentroEntregaOrderReceived: true,
    isShoworderTypeReceived: true,
    isShowDeliveryDateFromOrderReceived: true,
    isShowDeliveryDateToOrderReceived: true,

    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesEmit: true,
    isShowItemCodeSellerLinesEmit: true,
    isShowItemCodeBuyerLinesEmit: true,
    isShowGtin14CodeLinesEmit: false,
    isShowCentroEntregaLinesEmit: false,
    isShowDescriptionLinesEmit: true,
    isShowStatusLinesEmit: true,
    isShowQuantityLinesEmit: true,
    isShowMeasureLinesEmit: true,
    isShowNetPriceLinesEmit: false,
    isShowGrossPriceLinesEmit: false,
    isShowCurrencyLinesEmit: false,
    isShowTotalAmountLinesEmit: false,
    isShowDeliveryDateFromLinesEmit: false,
    isShowDeliveryDateToLinesEmit: false,
    isShowUnitOfMeasureTradeUnitLinesEmit: true,
    isShowQuantityTradeUnitLinesEmit: true,
    isShowQuantityRemainingEmit: true,

    // Columnas Tabla lineas recibidas
    isShowItemCodeLinesReceived: true,
    isShowItemCodeSellerLinesReceived: true,
    isShowItemCodeBuyerLinesReceived: true,
    isShowGtin14CodeLinesReceived: false,
    isShowCentroEntregaLinesReceived: false,
    isShowDescriptionLinesReceived: true,
    isShowStatusLinesReceived: true,
    isShowQuantityLinesReceived: true,
    isShowMeasureLinesReceived: true,
    isShowNetPriceLinesReceived: false,
    isShowGrossPriceLinesReceived: false,
    isShowCurrencyLinesReceived: false,
    isShowTotalAmountLinesReceived: false,
    isShowDeliveryDateFromLinesReceived: false,
    isShowDeliveryDateToLinesReceived: false,
    isShowUnitOfMeasureTradeUnitLinesReceived: true,
    isShowQuantityTradeUnitLinesReceived: true,
    isShowQuantityRemainingReceived: true
  }
  return local
}
function setByUserLocalOrder () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos) {
    const local = {
      // Columnas Tabla Pedidos Emitidas
      isShowBuyerOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowBuyerOrderEmit,
      isShowSellerOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowSellerOrderEmit,
      isShowNumOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowNumOrderEmit,
      isShowDateCreationOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDateCreationOrderEmit,
      isShowDateIssueOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDateIssueOrderEmit,
      isShowStatusOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowStatusOrderEmit,
      isShowServiceOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowServiceOrderEmit,
      isShowCentroVendedorOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroVendedorOrderEmit,
      isShowCentroCompradorOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroCompradorOrderEmit,
      isShowCentroEntregaOrderEmit:JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroEntregaOrderEmit,
      isShoworderTypeEmit:JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShoworderTypeEmit,
      isShowDeliveryDateFromOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateFromOrderEmit,
      isShowDeliveryDateToOrderEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateToOrderEmit,

      // Columnas Tabla Pedidos recibidas
      isShowBuyerOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowBuyerOrderReceived,
      isShowSellerOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowSellerOrderReceived,
      isShowNumOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowNumOrderReceived,
      isShowDateCreationOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDateCreationOrderReceived,
      isShowDateIssueOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDateIssueOrderReceived,
      isShowStatusOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowStatusOrderReceived,
      isShowServiceOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowServiceOrderReceived,
      isShowCentroVendedorOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroVendedorOrderReceived,
      isShowCentroCompradorOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroCompradorOrderReceived,
      isShowCentroEntregaOrderReceived:JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroEntregaOrderReceived,
      isShoworderTypeReceived:JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShoworderTypeReceived,
      isShowDeliveryDateFromOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateFromOrderReceived,
      isShowDeliveryDateToOrderReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateToOrderReceived,
    
      // Columnas tabla lineas emitidas
      isShowItemCodeLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowItemCodeLinesEmit,
      isShowItemCodeSellerLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowItemCodeSellerLinesEmit,
      isShowItemCodeBuyerLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowItemCodeBuyerLinesEmit,
      isShowGtin14CodeLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowGtin14CodeLinesEmit,
      isShowCentroEntregaLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroEntregaLinesEmit,
      isShowDescriptionLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDescriptionLinesEmit,
      isShowStatusLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowStatusLinesEmit,
      isShowQuantityLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowQuantityLinesEmit,
      isShowMeasureLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowMeasureLinesEmit,
      isShowNetPriceLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowNetPriceLinesEmit,
      isShowGrossPriceLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowGrossPriceLinesEmit,
      isShowCurrencyLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCurrencyLinesEmit,
      isShowTotalAmountLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowTotalAmountLinesEmit,
      isShowDeliveryDateFromLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateFromLinesEmit,
      isShowDeliveryDateToLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateToLinesEmit,
      isShowUnitOfMeasureTradeUnitLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowUnitOfMeasureTradeUnitLinesEmit,
      isShowQuantityTradeUnitLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowQuantityTradeUnitLinesEmit,
      isShowQuantityRemainingEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowQuantityRemainingEmit,

      // Columnas tabla lineas recibidas
      isShowItemCodeLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowItemCodeLinesReceived,
      isShowItemCodeSellerLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowItemCodeSellerLinesReceived,
      isShowItemCodeBuyerLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowItemCodeBuyerLinesReceived,
      isShowGtin14CodeLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowGtin14CodeLinesReceived,
      isShowCentroEntregaLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCentroEntregaLinesReceived,
      isShowDescriptionLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDescriptionLinesReceived,
      isShowStatusLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowStatusLinesReceived,
      isShowQuantityLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowQuantityLinesReceived,
      isShowMeasureLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowMeasureLinesReceived,
      isShowNetPriceLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowNetPriceLinesReceived,
      isShowGrossPriceLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowGrossPriceLinesReceived,
      isShowCurrencyLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowCurrencyLinesReceived,
      isShowTotalAmountLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowTotalAmountLinesReceived,
      isShowDeliveryDateFromLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateFromLinesReceived,
      isShowDeliveryDateToLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowDeliveryDateToLinesReceived,
      isShowUnitOfMeasureTradeUnitLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowUnitOfMeasureTradeUnitLinesReceived,
      isShowQuantityTradeUnitLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowQuantityTradeUnitLinesReceived,
      isShowQuantityRemainingReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).pedidos.isShowQuantityRemainingReceived,
    }
    return local
  } else {
    return initLocal()
  }
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla Pedidos Emitidas
    isShowBuyerOrderEmit: true,
    isShowSellerOrderEmit: true,
    isShowNumOrderEmit: true,
    isShowDateCreationOrderEmit: true,
    isShowDateIssueOrderEmit: true,
    isShowStatusOrderEmit: true,
    isShowServiceOrderEmit: true,
    isShowCentroVendedorOrderEmit: false,
    isShowCentroCompradorOrderEmit: false,
    isShowCentroEntregaOrderEmit: true,
    isShoworderTypeEmit: true,
    isShowDeliveryDateFromOrderEmit: true,
    isShowDeliveryDateToOrderEmit: true,

    // Columnas Tabla Pedidos recibidas
    isShowBuyerOrderReceived: true,
    isShowSellerOrderReceived: false,
    isShowNumOrderReceived: true,
    isShowDateCreationOrderReceived: false,
    isShowDateIssueOrderReceived: true,
    isShowStatusOrderReceived: true,
    isShowServiceOrderReceived: false,
    isShowCentroVendedorOrderReceived: false,
    isShowCentroCompradorOrderReceived: true,
    isShowCentroEntregaOrderReceived: true,
    isShoworderTypeReceived: true,
    isShowDeliveryDateFromOrderReceived: true,
    isShowDeliveryDateToOrderReceived: true,

    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesEmit: true,
    isShowItemCodeSellerLinesEmit: true,
    isShowItemCodeBuyerLinesEmit: true,
    isShowGtin14CodeLinesEmit: false,
    isShowCentroEntregaLinesEmit: false,
    isShowDescriptionLinesEmit: true,
    isShowStatusLinesEmit: true,
    isShowQuantityLinesEmit: true,
    isShowMeasureLinesEmit: true,
    isShowNetPriceLinesEmit: true,
    isShowGrossPriceLinesEmit: true,
    isShowCurrencyLinesEmit: true,
    isShowTotalAmountLinesEmit: true,
    isShowDeliveryDateFromLinesEmit: true,
    isShowDeliveryDateToLinesEmit: true,
    isShowUnitOfMeasureTradeUnitLinesEmit: true,
    isShowQuantityTradeUnitLinesEmit: true,
    isShowQuantityRemainingEmit: true,

    // Columnas Tabla lineas recibidas
    isShowItemCodeLinesReceived: true,
    isShowItemCodeSellerLinesReceived: true,
    isShowItemCodeBuyerLinesReceived: true,
    isShowGtin14CodeLinesReceived: false,
    isShowCentroEntregaLinesReceived: false,
    isShowDescriptionLinesReceived: true,
    isShowStatusLinesReceived: true,
    isShowQuantityLinesReceived: true,
    isShowMeasureLinesReceived: true,
    isShowNetPriceLinesReceived: true,
    isShowGrossPriceLinesReceived: true,
    isShowCurrencyLinesReceived: true,
    isShowTotalAmountLinesReceived: true,
    isShowDeliveryDateFromLinesReceived: true,
    isShowDeliveryDateToLinesReceived: true,
    isShowUnitOfMeasureTradeUnitLinesReceived: true,
    isShowQuantityTradeUnitLinesReceived: true,
    isShowQuantityRemainingReceived: true,
  },

  session: initSession()
}

// getters
const getters = {
  // Datos Tabla Pedidos Emitidas
  ordersEmit: state => {
    return state.session.ordersEmit
  },
  queryOrdersEmit: state => {
    return state.session.queryOrdersEmit
  },
  listSelectedFiltersOrdersEmit: state => {
    return state.session.listSelectedFiltersOrdersEmit
  },

  // Datos Tabla Pedidos Recibidas
  ordersReceived: state => {
    return state.session.ordersReceived
  },
  queryOrdersReceived: state => {
    return state.session.queryOrdersReceived
  },
  listSelectedFiltersOrdersReceived: state => {
    return state.session.listSelectedFiltersOrdersReceived
  },

  // Datos Select Filtros Pedidos Emitidas
  optionsFilterBuyerOrderEmit: state => {
    return state.session.optionsFilterBuyerOrderEmit
  },
  optionsFilterSellerOrderEmit: state => {
    return state.session.optionsFilterSellerOrderEmit
  },
  optionsFilterDateCreationOrderEmit: state => {
    return state.session.optionsFilterDateCreationOrderEmit
  },
  optionsFilterDateIssueOrderEmit: state => {
    return state.session.optionsFilterDateIssueOrderEmit
  },
  optionsFilterDeliveryDateFromOrderEmit: state => {
    return state.session.optionsFilterDeliveryDateFromOrderEmit
  },
  optionsFilterDeliveryDateToOrderEmit: state => {
    return state.session.optionsFilterDeliveryDateToOrderEmit
  },
  optionsFilterOrderNumberOrderEmit: state => {
    return state.session.optionsFilterOrderNumberOrderEmit
  },
  // Datos Select Filtros Pedidos Recibidas
  optionsFilterBuyerOrderReceived: state => {
    return state.session.optionsFilterBuyerOrderReceived
  },
  optionsFilterSellerOrderReceived: state => {
    return state.session.optionsFilterSellerOrderReceived
  },
  optionsFilterDateCreationOrderReceived: state => {
    return state.session.optionsFilterDateCreationOrderReceived
  },
  optionsFilterDateIssueOrderReceived: state => {
    return state.session.optionsFilterDateIssueOrderReceived
  },
  optionsFilterDeliveryDateFromOrderReceived: state => {
    return state.session.optionsFilterDeliveryDateFromOrderReceived
  },
  optionsFilterDeliveryDateToOrderReceived: state => {
    return state.session.optionsFilterDeliveryDateToOrderReceived
  },
  optionsFilterOrderNumberOrderReceived: state => {
    return state.session.optionsFilterOrderNumberOrderReceived
  },
  // Combo estados
  optionsFilterStatusOrder: state => {
    return state.session.optionsFilterStatusOrder
  },
  optionsFilterOrderType: state => {
    return state.session.optionsFilterOrderType
  },
  // Columnas Tabla Pedidos Emitidas
  isShowBuyerOrderEmit: state => {
    return state.local.isShowBuyerOrderEmit
  },
  isShowSellerOrderEmit: state => {
    return state.local.isShowSellerOrderEmit
  },
  isShowNumOrderEmit: state => {
    return state.local.isShowNumOrderEmit
  },
  isShowDateCreationOrderEmit: state => {
    return state.local.isShowDateCreationOrderEmit
  },
  isShowDateIssueOrderEmit: state => {
    return state.local.isShowDateIssueOrderEmit
  },
  isShowStatusOrderEmit: state => {
    return state.local.isShowStatusOrderEmit
  },
  isShowServiceOrderEmit: state => {
    return state.local.isShowServiceOrderEmit
  },
  isShowCentroVendedorOrderEmit: state => {
    return state.local.isShowCentroVendedorOrderEmit
  },
  isShowCentroCompradorOrderEmit: state => {
    return state.local.isShowCentroCompradorOrderEmit
  },
  isShowCentroEntregaOrderEmit: state => {
    return state.local.isShowCentroEntregaOrderEmit
  },
  isShoworderTypeEmit: state => {
    return state.local.isShoworderTypeEmit
  },
  isShowDeliveryDateFromOrderEmit: state => {
    return state.local.isShowDeliveryDateFromOrderEmit
  },
  isShowDeliveryDateToOrderEmit: state => {
    return state.local.isShowDeliveryDateToOrderEmit
  },

  // Columnas Tabla Pedidos Recibidas
  isShowBuyerOrderReceived: state => {
    return state.local.isShowBuyerOrderReceived
  },
  isShowSellerOrderReceived: state => {
    return state.local.isShowSellerOrderReceived
  },
  isShowNumOrderReceived: state => {
    return state.local.isShowNumOrderReceived
  },
  isShowDateCreationOrderReceived: state => {
    return state.local.isShowDateCreationOrderReceived
  },
  isShowDateIssueOrderReceived: state => {
    return state.local.isShowDateIssueOrderReceived
  },
  isShowStatusOrderReceived: state => {
    return state.local.isShowStatusOrderReceived
  },
  isShowServiceOrderReceived: state => {
    return state.local.isShowServiceOrderReceived
  },
  isShowCentroVendedorOrderReceived: state => {
    return state.local.isShowCentroVendedorOrderReceived
  },
  isShowCentroCompradorOrderReceived: state => {
    return state.local.isShowCentroCompradorOrderReceived
  },
  isShowCentroEntregaOrderReceived: state => {
    return state.local.isShowCentroEntregaOrderReceived
  },
  isShoworderTypeReceived: state => {
    return state.local.isShoworderTypeReceived
  },
  isShowDeliveryDateFromOrderReceived: state => {
    return state.local.isShowDeliveryDateFromOrderReceived
  },
  isShowDeliveryDateToOrderReceived: state => {
    return state.local.isShowDeliveryDateToOrderReceived
  },
  // Columnas lineas pedido emitidas
  isShowItemCodeLinesEmit: state => {
    return state.local.isShowItemCodeLinesEmit
  },
  isShowItemCodeSellerLinesEmit: state => {
    return state.local.isShowItemCodeSellerLinesEmit
  },
  isShowItemCodeBuyerLinesEmit: state => {
    return state.local.isShowItemCodeBuyerLinesEmit
  },
  isShowGtin14CodeLinesEmit: state => {
    return state.local.isShowGtin14CodeLinesEmit
  },
  isShowCentroEntregaLinesEmit: state => {
    return state.local.isShowCentroEntregaLinesEmit
  },
  isShowDescriptionLinesEmit: state => {
    return state.local.isShowDescriptionLinesEmit
  },
  isShowStatusLinesEmit: state => {
    return state.local.isShowStatusLinesEmit
  },
  isShowQuantityLinesEmit: state => {
    return state.local.isShowQuantityLinesEmit
  },
  isShowMeasureLinesEmit: state => {
    return state.local.isShowMeasureLinesEmit
  },
  isShowQuantityTradeUnitLinesEmit: state => {
    return state.local.isShowQuantityTradeUnitLinesEmit
  },
  isShowUnitOfMeasureTradeUnitLinesEmit: state => {
    return state.local.isShowUnitOfMeasureTradeUnitLinesEmit
  },
  isShowQuantityRemainingEmit: state => {
    return state.local.isShowQuantityRemainingEmit
  },
  isShowNetPriceLinesEmit: state => {
    return state.local.isShowNetPriceLinesEmit
  },
  isShowGrossPriceLinesEmit: state => {
    return state.local.isShowGrossPriceLinesEmit
  },
  isShowCurrencyLinesEmit: state => {
    return state.local.isShowCurrencyLinesEmit
  },
  isShowTotalAmountLinesEmit: state => {
    return state.local.isShowTotalAmountLinesEmit
  },
  isShowDeliveryDateFromLinesEmit: state => {
    return state.local.isShowDeliveryDateFromLinesEmit
  },
  isShowDeliveryDateToLinesEmit: state => {
    return state.local.isShowDeliveryDateToLinesEmit
  },
  // Columnas lineas pedido recibidas
  isShowItemCodeLinesReceived: state => {
    return state.local.isShowItemCodeLinesReceived
  },
  isShowItemCodeSellerLinesReceived: state => {
    return state.local.isShowItemCodeSellerLinesReceived
  },
  isShowItemCodeBuyerLinesReceived: state => {
    return state.local.isShowItemCodeBuyerLinesReceived
  },
  isShowGtin14CodeLinesReceived: state => {
    return state.local.isShowGtin14CodeLinesReceived
  },
  isShowCentroEntregaLinesReceived: state => {
    return state.local.isShowCentroEntregaLinesReceived
  },
  isShowDescriptionLinesReceived: state => {
    return state.local.isShowDescriptionLinesReceived
  },
  isShowStatusLinesReceived: state => {
    return state.local.isShowStatusLinesReceived
  },
  isShowQuantityLinesReceived: state => {
    return state.local.isShowQuantityLinesReceived
  },
  isShowMeasureLinesReceived: state => {
    return state.local.isShowMeasureLinesReceived
  },
  isShowQuantityTradeUnitLinesReceived: state => {
    return state.local.isShowQuantityTradeUnitLinesReceived
  },
  isShowUnitOfMeasureTradeUnitLinesReceived: state => {
    return state.local.isShowUnitOfMeasureTradeUnitLinesReceived
  },
  isShowQuantityRemainingReceived: state => {
    return state.local.isShowQuantityRemainingReceived
  },
  isShowNetPriceLinesReceived: state => {
    return state.local.isShowNetPriceLinesReceived
  },
  isShowGrossPriceLinesReceived: state => {
    return state.local.isShowGrossPriceLinesReceived
  },
  isShowCurrencyLinesReceived: state => {
    return state.local.isShowCurrencyLinesReceived
  },
  isShowTotalAmountLinesReceived: state => {
    return state.local.isShowTotalAmountLinesReceived
  },
  isShowDeliveryDateFromLinesReceived: state => {
    return state.local.isShowDeliveryDateFromLinesReceived
  },
  isShowDeliveryDateToLinesReceived: state => {
    return state.local.isShowDeliveryDateToLinesReceived
  }
}

// actions
const actions = {
  // Crear key Usuario
  // Crear key Usuario
  setUserNameOrder ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalOrder()
    }
  },
  async isNewVersionPedidosLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.pedidos)
    return isnew
  },

  /* PEDIDOS */
  /**
  * Servicio para traer las pedidos emitidas y recibidas .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getOrders ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order',
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      commit('ORDERS_EMIT_STATE', {
        tableData: response.data.content,
        totalOrdersEmit: response.data.totalElements
      })

      commit('ORDERS_RECEIVED_STATE', {
        tableData: response.data.content,
        totalOrdersReceived: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de una pedido
  async getOrderDetail ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/' + params.orderID,
        params: {
          searchType: params.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Servicio de modificacion de pedido
  async modifyOrder ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/order/' + data.orderId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.dataQuery.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Servicio de modificacion de líneas de pedido
  async modifyOrderLines ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/order/' + data.orderId + '/lines',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.dataQuery.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },  
  async downloadOrderPdfMultiple ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/pdf',
        params: {
          ordersId: params.ordersId,
          searchType: params.searchType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'pdfs-pedidos.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async downloadOrderOriginal ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/original',
        params: {
          ordersId: params.orderId,
          searchType: params.searchType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'pedido-original.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async downloadOrderMetadata ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/metadata',
        params: {
          ordersId: params.orderId,
          searchType: params.searchType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'pedido-original.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async downloadOrderResponseDocument ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/response',
        params: {
          orderResponseId: params.orderResponseId,
          searchType: params.searchType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'respuesta-pedido-original.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async downloadOrderResponsePdf ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/responsePdf',
        params: {
          orderResponseId: params.orderResponseId,
          searchType: params.searchType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'respuesta-pedido-pdf.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para generar el order response
  */
  async generateOrdrsp ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/' + request.orderId + '/generateOrdrsp/',
        data: {
          orderLineChanged: request.orderLineChanged,
          orderResponseNumber: request.orderResponseNumber,
          newStatus: request.newStatus
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los tipos de estados de las pedidos emitidas y recibidas
   */
  async getOptionsFilterStatusOrder ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/orderstatus'
      })

      const optionsFilterStatusOrder = response.data
      commit('OPTIONS_FILTER_STATUS_ORDERS', optionsFilterStatusOrder)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterStatusOrder
    } catch (error) {
      console.log('status order : ', error)
      throw error.response
    }
  },

  async getOptionsFilterOrderType ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/ordertype'
      })

      const optionsFilterOrderType = response.data
      commit('OPTIONS_FILTER_ORDER_TYPE', optionsFilterOrderType)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterOrderType
    } catch (error) {
      console.log('orderType order : ', error)
      throw error.response
    }
  },

  /**
   * Servicio para obtener las lineas de un pedido emitido o recibido
   */
  async getOrderLines ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/' + data.query.orderId + '/lines',
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener los documentos relacionados de un pedido emitido o recibido
   */
  async getRelatedDocuments ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/' + data.query.orderId + '/relatedDocuments',
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener los cargos y descuentos de un pedido emitido o recibido
   */
  async getChargesDiscounts ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/' + data.query.orderId + '/chargeDiscount',
        params: {
          searchType: data.query.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener las respuestas de un pedido recibido
   */
  async getOrderResponses ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/order/' + data.query.orderId + '/responses',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: data.query.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para Exportar Todas las Pedidos  a CSV
     */
  async downloadOrderCsv ({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/order/csv',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'orders.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla Pedidos Emitidas
  ordersEmitState: ({ commit }, payload) => {
    commit('ORDERS_EMIT_STATE', payload)
  },
  queryOrdersEmitState: ({ commit }, payload) => {
    commit('QUERY_ORDERS_EMIT_STATE', payload)
  },
  listSelectedFiltersOrdersEmitState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_ORDERS_EMIT_STATE', payload)
  },

  // Datos Tabla Pedidos Recibidas
  ordersReceivedState: ({ commit }, payload) => {
    commit('ORDERS_RECEIVED_STATE', payload)
  },
  queryOrdersReceivedState: ({ commit }, payload) => {
    commit('QUERY_ORDERS_RECEIVED_STATE', payload)
  },
  listSelectedFiltersOrdersReceivedState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_ORDERS_RECEIVED_STATE', payload)
  },

  // Datos Select Filtros Pedidos Emitidas
  optionsFilterBuyerOrderEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_ORDERS_EMIT', payload)
  },
  optionsFilterSellerOrderEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_ORDERS_EMIT', payload)
  },
  optionsFilterDateCreationOrderEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_ORDERS_EMIT', payload)
  },
  optionsFilterDateIssueOrderEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_ORDERS_EMIT', payload)
  },
  optionsFilterDeliveryDateFromOrderEmitState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATEFROM_ORDERS_EMIT', payload)
  },
  optionsFilterDeliveryDateToOrderEmitState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATETO_ORDERS_EMIT', payload)
  },
  optionsFilterOrderNumberOrderEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_ORDER_NUMBER_ORDERS_EMIT', payload)
  },
  // Datos Select Filtros Pedidos Recibidas
  optionsFilterBuyerOrderReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_ORDERS_RECEIVED', payload)
  },
  optionsFilterSellerOrderReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_ORDERS_RECEIVED', payload)
  },
  optionsFilterDateCreationOrderReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_ORDERS_RECEIVED', payload)
  },
  optionsFilterDateIssueOrderReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_ORDERS_RECEIVED', payload)
  },
  optionsFilterDeliveryDateFromOrderReceivedState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATEFROM_ORDERS_RECEIVED', payload)
  },
  optionsFilterDeliveryDateToOrderReceivedState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATETO_ORDERS_RECEIVED', payload)
  },
  optionsFilterOrderNumberOrderReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_ORDER_NUMBER_ORDERS_RECEIVED', payload)
  },

  // Combo estados
  optionsFilterStatusOrderState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_STATUS_ORDERS', payload)
  },
  optionsFilterOrderTypeState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_ORDER_TYPE', payload)
  },

  // Columnas Tabla Pedidos Emitidas
  isShowBuyerOrderEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_ORDER_EMIT', payload)
  },
  isShowSellerOrderEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_ORDER_EMIT', payload)
  },
  isShowNumOrderEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_ORDER_EMIT', payload)
  },
  isShowDateCreationOrderEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_ORDER_EMIT', payload)
  },
  isShowDateIssueOrderEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_ISSUE_ORDER_EMIT', payload)
  },
  isShowStatusOrderEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_ORDER_EMIT', payload)
  },
  isShowServiceOrderEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_ORDER_EMIT', payload)
  },
  isShowCentroVendedorOrderEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_ORDER_EMIT', payload)
  },
  isShowCentroCompradorOrderEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_ORDER_EMIT', payload)
  },
  isShowCentroEntregaOrderEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_ORDER_EMIT', payload)
  },
  isShoworderTypeEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ORDER_TYPE_ORDER_EMIT', payload)
  }, 
  isShowDeliveryDateFromOrderEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DELIVERY_DATEFROM_ORDER_EMIT', payload)
  },
  isShowDeliveryDateToOrderEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DELIVERY_DATETO_ORDER_EMIT', payload)
  },

  // Columnas Tabla Pedidos Recibidas
  isShowBuyerOrderReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_ORDER_RECEIVED', payload)
  },
  isShowSellerOrderReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_ORDER_RECEIVED', payload)
  },
  isShowNumOrderReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_ORDER_RECEIVED', payload)
  },
  isShowDateCreationOrderReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_ORDER_RECEIVED', payload)
  },
  isShowDateIssueOrderReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_ISSUE_ORDER_RECEIVED', payload)
  },
  isShowStatusOrderReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_ORDER_RECEIVED', payload)
  },
  isShowServiceOrderReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_ORDER_RECEIVED', payload)
  },
  isShowCentroVendedorOrderReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_ORDER_RECEIVED', payload)
  },
  isShowCentroCompradorOrderReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_ORDER_RECEIVED', payload)
  },
  isShowCentroEntregaOrderReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_ORDER_RECEIVED', payload)
  },
  isShoworderTypeReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ORDER_TYPE_ORDER_RECEIVED', payload)
  }, 
  isShowDeliveryDateFromOrderReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DELIVERY_DATEFROM_ORDER_RECEIVED', payload)
  },
  isShowDeliveryDateToOrderReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DELIVERY_DATETO_ORDER_RECEIVED', payload)
  },
  // Columnas lineas emitidas
  isShowItemCodeLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODE_LINES_EMIT', payload)
  },
  isShowItemCodeSellerLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODESELLER_LINES_EMIT', payload)
  },
  isShowItemCodeBuyerLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODEBUYER_LINES_EMIT', payload)
  },
  isShowGtin14CodeLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_GTIN14CODE_LINES_EMIT', payload)
  },
  isShowCentroEntregaLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_CENTROENTREGA_LINES_EMIT', payload)
  },
  isShowDescriptionLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_LINES_EMIT', payload)
  },
  isShowStatusLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_LINES_EMIT', payload)
  },
  isShowQuantityLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_LINES_EMIT', payload)
  },
  isShowMeasureLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURE_LINES_EMIT', payload)
  },
  isShowQuantityTradeUnitLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURETRADEUNIT_LINES_EMIT', payload)
  },
  isShowUnitOfMeasureTradeUnitLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_EMIT', payload)
  },
  isShowQuantityRemainingEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASUREREMAINING_LINES_EMIT', payload)
  },
  isShowNetPriceLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_NETPRICE_LINES_EMIT', payload)
  },
  isShowGrossPriceLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_GROSSPRICE_LINES_EMIT', payload)
  },
  isShowCurrencyLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_CURRENCY_LINES_EMIT', payload)
  },
  isShowTotalAmountLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_TOTALAMOUNT_LINES_EMIT', payload)
  },
  isShowDeliveryDateFromLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERYDATEFROM_LINES_EMIT', payload)
  },
  isShowDeliveryDateToLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERYDATETO_LINES_EMIT', payload)
  },
  // Columnas lineas recibidas
  isShowItemCodeLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODE_LINES_RECEIVED', payload)
  },
  isShowItemCodeSellerLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODESELLER_LINES_RECEIVED', payload)
  },
  isShowItemCodeBuyerLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODEBUYER_LINES_RECEIVED', payload)
  },
  isShowGtin14CodeLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_GTIN14CODE_LINES_RECEIVED', payload)
  },
  isShowCentroEntregaLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_CENTROENTREGA_LINES_RECEIVED', payload)
  },
  isShowDescriptionLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_LINES_RECEIVED', payload)
  },
  isShowStatusLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_LINES_RECEIVED', payload)
  },
  isShowQuantityLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_LINES_RECEIVED', payload)
  },
  isShowMeasureLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURE_LINES_RECEIVED', payload)
  },
  isShowQuantityTradeUnitLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURETRADEUNIT_LINES_RECEIVED', payload)
  },
  isShowUnitOfMeasureTradeUnitLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_RECEIVED', payload)
  },
  isShowQuantityRemainingReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASUREREMAINING_LINES_RECEIVED', payload)
  },
  isShowNetPriceLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_NETPRICE_LINES_RECEIVED', payload)
  },
  isShowGrossPriceLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_GROSSPRICE_LINES_RECEIVED', payload)
  },
  isShowCurrencyLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_CURRENCY_LINES_RECEIVED', payload)
  },
  isShowTotalAmountLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_TOTALAMOUNT_LINES_RECEIVED', payload)
  },
  isShowDeliveryDateFromLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERYDATEFROM_LINES_RECEIVED', payload)
  },
  isShowDeliveryDateToLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERYDATETO_LINES_RECEIVED', payload)
  }
}

// mutations
const mutations = {
  resetSessionPedidos (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  orderDatesSuperAdmin (state) {
    state.session.queryOrdersEmit.creationDateTimeFrom = fn.initDateFrom(1)
    state.session.queryOrdersReceived.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Pedidos emitidas
  'ORDERS_EMIT_STATE' (state, payload) {
    state.session.ordersEmit = payload
  },
  'QUERY_ORDERS_EMIT_STATE' (state, payload) {
    state.session.queryOrdersEmit = payload
  },
  'LIST_SELECTED_FILTERS_ORDERS_EMIT_STATE' (state, payload) {
    state.session.listSelectedFiltersOrdersEmit = payload
  },

  // Pedidos Recibidas
  'ORDERS_RECEIVED_STATE' (state, payload) {
    state.session.ordersReceived = payload
  },
  'QUERY_ORDERS_RECEIVED_STATE' (state, payload) {
    state.session.queryOrdersReceived = payload
  },
  'LIST_SELECTED_FILTERS_ORDERS_RECEIVED_STATE' (state, payload) {
    state.session.listSelectedFiltersOrdersReceived = payload
  },

  // Datos Select Filtros Pedidos  Emitidas
  'OPTIONS_FILTER_BUYER_ORDERS_EMIT' (state, payload) {
    state.session.optionsFilterBuyerOrderEmit = payload
  },
  'OPTIONS_FILTER_SELLER_ORDERS_EMIT' (state, payload) {
    state.session.optionsFilterSellerOrderEmit = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_ORDERS_EMIT' (state, payload) {
    state.session.optionsFilterDateCreationOrderEmit = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_ORDERS_EMIT' (state, payload) {
    state.session.optionsFilterDateIssueOrderEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATEFROM_ORDERS_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryDateFromOrderEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATETO_ORDERS_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryDateToOrderEmit = payload
  },
  'OPTIONS_FILTER_ORDER_NUMBER_ORDERS_EMIT' (state, payload) {
    state.session.optionsFilterOrderNumberOrderEmit = payload
  },
  // Datos Select Filtros Pedidos Recibidas
  'OPTIONS_FILTER_BUYER_ORDERS_RECEIVED' (state, payload) {
    state.session.optionsFilterBuyerOrderReceived = payload
  },
  'OPTIONS_FILTER_SELLER_ORDERS_RECEIVED' (state, payload) {
    state.session.optionsFilterSellerOrderReceived = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_ORDERS_RECEIVED' (state, payload) {
    state.session.optionsFilterDateCreationOrderReceived = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_ORDERS_RECEIVED' (state, payload) {
    state.session.optionsFilterDateIssueOrderReceived = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATEFROM_ORDERS_RECEIVED' (state, payload) {
    state.session.optionsFilterDeliveryDateFromOrderReceived = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATETO_ORDERS_RECEIVED' (state, payload) {
    state.session.optionsFilterDeliveryDateToOrderReceived = payload
  },
  'OPTIONS_FILTER_ORDER_NUMBER_ORDERS_RECEIVED' (state, payload) {
    state.session.optionsFilterOrderNumberOrderReceived = payload
  },
  // Combo estados pedidos emitidas y recibidas
  'OPTIONS_FILTER_STATUS_ORDERS' (state, payload) {
    state.session.optionsFilterStatusOrder = payload
  },
  'OPTIONS_FILTER_ORDER_TYPE' (state, payload) {
    state.session.optionsFilterOrderType = payload
  },

  // Columnas Tabla Pedidos Emitidas
  'IS_SHOW_BUYER_ORDER_EMIT' (state, payload) {
    state.local.isShowBuyerOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowBuyerOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_ORDER_EMIT' (state, payload) {
    state.local.isShowSellerOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowSellerOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_ORDER_EMIT' (state, payload) {
    state.local.isShowNumOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowNumOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_ORDER_EMIT' (state, payload) {
    state.local.isShowDateCreationOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDateCreationOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_ISSUE_ORDER_EMIT' (state, payload) {
    state.local.isShowDateIssueOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDateIssueOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_ORDER_EMIT' (state, payload) {
    state.local.isShowStatusOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowStatusOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_ORDER_EMIT' (state, payload) {
    state.local.isShowServiceOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowServiceOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_ORDER_EMIT' (state, payload) {
    state.local.isShowCentroVendedorOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroVendedorOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_ORDER_EMIT' (state, payload) {
    state.local.isShowCentroCompradorOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroCompradorOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_ORDER_EMIT' (state, payload) {
    state.local.isShowCentroEntregaOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroEntregaOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_TYPE_ORDER_EMIT' (state, payload) {
    state.local.isShoworderTypeEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShoworderTypeEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_DATEFROM_ORDER_EMIT' (state, payload) {
    state.local.isShowDeliveryDateFromOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateFromOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_DATETO_ORDER_EMIT' (state, payload) {
    state.local.isShowDeliveryDateToOrderEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateToOrderEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // Columnas Tabla Pedidos Recibidas
  'IS_SHOW_BUYER_ORDER_RECEIVED' (state, payload) {
    state.local.isShowBuyerOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowBuyerOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_ORDER_RECEIVED' (state, payload) {
    state.local.isShowSellerOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowSellerOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_ORDER_RECEIVED' (state, payload) {
    state.local.isShowNumOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowNumOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_ORDER_RECEIVED' (state, payload) {
    state.local.isShowDateCreationOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDateCreationOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_ISSUE_ORDER_RECEIVED' (state, payload) {
    state.local.isShowDateIssueOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDateIssueOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_ORDER_RECEIVED' (state, payload) {
    state.local.isShowStatusOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowStatusOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_ORDER_RECEIVED' (state, payload) {
    state.local.isShowServiceOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowServiceOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_ORDER_RECEIVED' (state, payload) {
    state.local.isShowCentroVendedorOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroVendedorOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_ORDER_RECEIVED' (state, payload) {
    state.local.isShowCentroCompradorOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroCompradorOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_ORDER_RECEIVED' (state, payload) {
    state.local.isShowCentroEntregaOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroEntregaOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_TYPE_ORDER_RECEIVED' (state, payload) {
    state.local.isShoworderTypeReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShoworderTypeReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_DATEFROM_ORDER_RECEIVED' (state, payload) {
    state.local.isShowDeliveryDateFromOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateFromOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_DATETO_ORDER_RECEIVED' (state, payload) {
    state.local.isShowDeliveryDateToOrderReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateToOrderReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Columnas lineas emitidas
  'IS_SHOW_ITEMCODE_LINES_EMIT' (state, payload) {
    state.local.isShowItemCodeLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowItemCodeLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODESELLER_LINES_EMIT' (state, payload) {
    state.local.isShowItemCodeSellerLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowItemCodeSellerLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODEBUYER_LINES_EMIT' (state, payload) {
    state.local.isShowItemCodeBuyerLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowItemCodeBuyerLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GTIN14CODE_LINES_EMIT' (state, payload) {
    state.local.isShowGtin14CodeLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowGtin14CodeLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTROENTREGA_LINES_EMIT' (state, payload) {
    state.local.isShowCentroEntregaLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroEntregaLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_LINES_EMIT' (state, payload) {
    state.local.isShowDescriptionLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDescriptionLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_LINES_EMIT' (state, payload) {
    state.local.isShowStatusLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowStatusLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_LINES_EMIT' (state, payload) {
    state.local.isShowQuantityLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowQuantityLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURE_LINES_EMIT' (state, payload) {
    state.local.isShowMeasureLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowMeasureLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURETRADEUNIT_LINES_EMIT' (state, payload) {
    state.local.isShowQuantityTradeUnitLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowQuantityTradeUnitLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_EMIT' (state, payload) {
    state.local.isShowUnitOfMeasureTradeUnitLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowUnitOfMeasureTradeUnitLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASUREREMAINING_LINES_EMIT' (state, payload) {
    state.local.isShowQuantityRemainingEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowQuantityRemainingEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NETPRICE_LINES_EMIT' (state, payload) {
    state.local.isShowNetPriceLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowNetPriceLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GROSSPRICE_LINES_EMIT' (state, payload) {
    state.local.isShowGrossPriceLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowGrossPriceLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CURRENCY_LINES_EMIT' (state, payload) {
    state.local.isShowCurrencyLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCurrencyLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TOTALAMOUNT_LINES_EMIT' (state, payload) {
    state.local.isShowTotalAmountLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowTotalAmountLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERYDATEFROM_LINES_EMIT' (state, payload) {
    state.local.isShowDeliveryDateFromLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateFromLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERYDATETO_LINES_EMIT' (state, payload) {
    state.local.isShowDeliveryDateToLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateToLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Columnas lineas recibidas
  'IS_SHOW_ITEMCODE_LINES_RECEIVED' (state, payload) {
    state.local.isShowItemCodeLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowItemCodeLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODESELLER_LINES_RECEIVED' (state, payload) {
    state.local.isShowItemCodeSellerLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowItemCodeSellerLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEMCODEBUYER_LINES_RECEIVED' (state, payload) {
    state.local.isShowItemCodeBuyerLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowItemCodeBuyerLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GTIN14CODE_LINES_RECEIVED' (state, payload) {
    state.local.isShowGtin14CodeLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowGtin14CodeLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTROENTREGA_LINES_RECEIVED' (state, payload) {
    state.local.isShowCentroEntregaLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCentroEntregaLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_LINES_RECEIVED' (state, payload) {
    state.local.isShowDescriptionLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDescriptionLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_LINES_RECEIVED' (state, payload) {
    state.local.isShowStatusLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowStatusLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_LINES_RECEIVED' (state, payload) {
    state.local.isShowQuantityLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowQuantityLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURE_LINES_RECEIVED' (state, payload) {
    state.local.isShowMeasureLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowMeasureLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURETRADEUNIT_LINES_RECEIVED' (state, payload) {
    state.local.isShowQuantityTradeUnitLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowQuantityTradeUnitLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_UNITOFMEASURETRADEUNIT_LINES_RECEIVED' (state, payload) {
    state.local.isShowUnitOfMeasureTradeUnitLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowUnitOfMeasureTradeUnitLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASUREREMAINING_LINES_RECEIVED' (state, payload) {
    state.local.isShowQuantityRemainingReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowQuantityRemainingReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NETPRICE_LINES_RECEIVED' (state, payload) {
    state.local.isShowNetPriceLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowNetPriceLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GROSSPRICE_LINES_RECEIVED' (state, payload) {
    state.local.isShowGrossPriceLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowGrossPriceLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CURRENCY_LINES_RECEIVED' (state, payload) {
    state.local.isShowCurrencyLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowCurrencyLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TOTALAMOUNT_LINES_RECEIVED' (state, payload) {
    state.local.isShowTotalAmountLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowTotalAmountLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERYDATEFROM_LINES_RECEIVED' (state, payload) {
    state.local.isShowDeliveryDateFromLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateFromLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERYDATETO_LINES_RECEIVED' (state, payload) {
    state.local.isShowDeliveryDateToLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.pedidos.isShowDeliveryDateToLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
